import React from "react";
import { ProjectOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useIntl } from "react-intl";
// import { Link } from "react-router-dom";
// import { getAdminPath } from "../../../util/router";
import IntlMessages from "../../../util/IntlMessages";

const TaskManagerToolbarIcon = () => {
   const intl = useIntl();

   return (
      // <Link to={getAdminPath("task-manager")}>
      <a
         href={"https://tasks.tecnodataecogreen.it"}
         target="_blank"
         rel="noopener noreferrer"
      >
         <Tooltip title={intl.formatMessage({ id: "common.task-manager" })}>
            <div
               style={{
                  backgroundColor: "cyan",
                  padding: "6px 10px",
                  borderRadius: 20,
               }}
               className="gx-mt-3"
            >
               <ProjectOutlined className="gx-mr-1" />
               <IntlMessages id="common.task-manager" />
            </div>
         </Tooltip>
      </a>
      // </Link>
   );
};

export default TaskManagerToolbarIcon;
